import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class BrokerAppDataService {
  constructor() {}

  emailFromLogin!: string;
}
